import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FeedItemDto, FetchError } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

const useGetCommentsFeedRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getCommentsFeedRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.comments.getCommentsFeed>>): Promise<FeedItemDto[]> {
    const accessToken = await getAccessToken();
    const [{ threadGuid }] = queryKey;
    const url = new URL(`${configuration.apiRootUrl}/threads/${threadGuid}/feed`);

    const response = await fetch(url.href, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getCommentsFeedRequest };
};

const useGetCommentsFeed = (threadGuid: string | undefined) => {
  const { getCommentsFeedRequest } = useGetCommentsFeedRequest();

  return useQuery({
    queryKey: queryKeys.comments.getCommentsFeed(threadGuid),
    queryFn: getCommentsFeedRequest,
    enabled: threadGuid !== undefined,
  });
};

export { useGetCommentsFeed };
